<template>
  <div class="text-center mt-3">
    <v-dialog transition="dialog-top-transition" max-width="21rem" v-model="showPopup" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" fab dark small color="teal" v-bind="attrs" v-on="on" v-if="selectedLocation.nasid && (couponOnlyFlowNasids.indexOf(selectedLocation.nasid) < 0)">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
        <p v-if="selectedLocation.nasid && (couponOnlyFlowNasids.indexOf(selectedLocation.nasid) < 0)" class="mb-0 mt-1" v-text="templateModel.plusButtonText"></p>
      </template>
      <template v-slot:default="dialog">
        <v-card class="px-3 py-3">
          <v-card-title class="headline px-3 py-3 text-subtitle-1 font-weight-bold">
            <div style="margin: 0 auto;" v-text="templateModel.header"></div>
          </v-card-title>
          <v-card-text class="pb-0 px-3" v-if="templateModel.screen=='policy'">
            <div class="plan-field-row">
              <p class="mb-0 mandatory" style="color:#000">Data</p>
              <v-select :items="templateModel.unitsOfData" v-model="templateModel.dataUnit" dense flat solo outlined
                style="display:inline-block;width:50%;border-top-right-radius:0;border-bottom-right-radius:0;">
              </v-select>
              <v-text-field placeholder="eg:20" class="pt-0" outlined dense v-model="templateModel.data" type="text"
                inputmode="numeric"
                style="display:inline-block;border-top-left-radius:0;border-bottom-left-radius:0;width:50%">
              </v-text-field>
            </div>

            <div class="plan-field-row">
              <p class="mb-0 mandatory" style="color:#000">Time</p>
              <v-select :items="templateModel.unitsOfTime" v-model="templateModel.timeUnit" dense flat solo outlined
                style="display:inline-block;width:50%;border-top-right-radius:0;border-bottom-right-radius:0;">
              </v-select>
              <v-text-field placeholder="eg:20" class="pt-0" outlined dense v-model="templateModel.time" type="text"
                inputmode="numeric"
                style="display:inline-block;border-top-left-radius:0;border-bottom-left-radius:0;width:50%">
              </v-text-field>
            </div>
            <!-- <div class="plan-field-row">
              <p class="mb-0 mandatory" style="color:#000">Devices</p>
              <v-text-field placeholder="eg: 2" class="pt-0" outlined dense v-model="templateModel.deviceCount"
                type="text" inputmode="numeric" maxlength="2">
              </v-text-field>
            </div> -->
            <div class="plan-field-row">
              <div style="display:flex;justify-content:space-between;">
                <p class="mb-0 mandatory" style="color:#000">Amount</p>
                <v-checkbox v-model="templateModel.isFreePlan" :value="templateModel.isFreePlan" color="#f06b69"
                  label="Free Plan" class="mt-0 pt-0" style="height:1.75rem;color:#f06b69;"></v-checkbox>
              </div>
              <v-text-field placeholder="eg: â‚¹10" class="pt-0" outlined dense v-model="templateModel.price" type="text"
                inputmode="numeric" :disabled="templateModel.isFreePlan">
              </v-text-field>
            </div>

            <v-btn v-if="buttons.RED" class="font-weight-bold text-capitalize" block color="error" 
              @click="buttons.RED.action({dialog: dialog});" :disabled="redDisabled()">
              {{buttons.RED.text}}
            </v-btn>
            <v-btn v-if="buttons.GREY" block text @click="close({dialog: dialog})" class="font-weight-bold text-capitalize mt-2">
              {{buttons.GREY.text}}
            </v-btn>
          </v-card-text>
          <v-card-text class="pb-0 px-3" v-if="templateModel.screen=='phone-number'">
            <div class="plan-field-row">
              <h2 style="color:#000;margin-bottom: 1rem; text-align:center;">Phone Number</h2>
              <v-text-field placeholder="eg: 8883022222" class="pt-0" outlined dense v-model="templateModel.mobile"
                type="text" inputmode="numeric" @keypress="isNumber($event)" maxlength="10">
              </v-text-field>
            </div>
            <v-btn v-if="buttons.RED" class="font-weight-bold text-capitalize" block color="error" 
              @click="sendNow({dialog: dialog});" :disabled="redDisabled()">
              Send Now
            </v-btn>
            <v-btn v-if="buttons.GREY" block text @click="close({dialog: dialog})" class="font-weight-bold text-capitalize mt-2">
              {{buttons.GREY.text}}
            </v-btn>
            <a id="smser" style="display:none" href=""></a>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<style scoped lang="scss">
  .plan-field-row {
    font-size: 1em;
  }
</style>

<script>
  import WIOM_APIS from '../../../utils/wiom-apis';
  import helper from '../../../utils/helper';
  export default {
    props: ["type", "selectedLocation", "coupon"],
    data: function () {
      return {
        couponOnlyFlowNasids: [10916,10911,9740,9746,9951,9749],
        showPopup: false,
        myTypes: {
          CREATE_PLAN: 'create-plan',
          SEND_COUPON: 'send-voucher'
        },
        buttons: {
          GREY: {
            action: this.close,
            text: 'Cancel'
          },
          RED: {
            action: this.close,
            text: 'Ok',
            disabled: () => {return false}
          },
          ACTIVATOR: {
            text: 'Create Plan',
            type: ''
          }
        },
        templateModel: {
          data: '',
          time: '',
          price: '',
          devices: 1,
          showCreatePlanPopup: false,
          screen: 'policy',
          isFreePlan: false,
          dataUnit: "MB",
          timeUnit: "Min.",
          showSuccessPopup: false,
          header: '',
          plusButtonText: '',
          unitsOfData: ["MB", "GB"],
          unitsOfTime: ["Min.", "Hours", "Day"],
        }
      }
    },
    mounted: function () {
      switch (this.type) {
        case this.myTypes.SEND_COUPON:
          this.buttons.RED.text = 'Next';
          this.buttons.RED.action = this.sendNowPhScreen
          this.templateModel.header = 'Send Coupon';
          this.templateModel.plusButtonText = 'Create your own Coupon';
          break;
        case this.myTypes.CREATE_PLAN:
          this.templateModel.header = 'Create Plan'
          this.templateModel.plusButtonText = 'Create Plan';
          this.buttons.RED.text = 'Create';
          this.buttons.RED.action = this.createPlan;
          this.buttons.RED.disabled = () => {
            let isPrice = this.templateModel.isFreePlan || (this.templateModel.price > 0);
            return !(isPrice && this.templateModel.data > 0 && this.templateModel.time > 0 && 
              this.templateModel.devices >= 1 && this.templateModel.devices <= 20);
          }
          break;
      }
    },
    methods: {
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
      redDisabled: function() {
        let isPrice = this.templateModel.isFreePlan || (this.templateModel.price >= 0);
        let ret = (isPrice && this.templateModel.data > 0 && this.templateModel.time > 0 && 
          this.templateModel.devices >= 1 && this.templateModel.devices <= 20)
        if (this.templateModel.screen == 'policy') {
          if (this.templateModel.dataUnit == 'GB' && parseInt(this.templateModel.data) > 500)          
            return true;
          if (this.templateModel.dataUnit == 'MB' && parseInt(this.templateModel.data) > 512000)          
            return true;
        }
        if (this.templateModel.screen == 'phone-number') {
          console.log("this.templateModel.mobile", this.templateModel.mobile, ret)
          return !(ret && this.templateModel.mobile && this.templateModel.mobile.length == 10);
        } else {
          return !ret;
        }
      },
      createPlan: function (options) {
        let plan = this.getPlan();
        this.$emit('emitted-plan', plan);
        this.close(options);
      },
      sendNowPhScreen: function(options) {
        console.log(options)
        this.templateModel.screen = 'phone-number';
      },
      createCoupon: function(coupon) {
        this.templateModel.devices = 1; //coupon.concurrent_devices;
        this.templateModel.time = coupon.time_limit;
        this.templateModel.data = coupon.data_limit;
        this.templateModel.price = coupon.price;
        this.templateModel.dataUnit = "MB";
        this.templateModel.timeUnit = "Sec";
        this.sendNowPhScreen();
        this.showPopup = true;
      },
      sendNow: function (options) {
        let plan = this.getPlan();
        let extraData = {
          bought_from: 'wiom_dashboard',
          bought_from_nas: this.selectedLocation.nasid,
          sent_to: this.templateModel.mobile,
          payment_mode: "digital coupon"
        }
        let voucher = {
          mobile: ' ',
          nasid: this.selectedLocation.nasid,
          extraDataObject: extraData,
          dataPlan: plan.data_limit,
          timePlan: plan.time_limit,
          charges: plan.price
        };

        WIOM_APIS.createUser(voucher).then((response) => {
          console.log(response)
          if (response.status == 0) {
            let smser = document.getElementById("smser");
            let text =
              `Hi! You have received a Rs. ${plan.price} coupon: ${response.data.coupon_code} from ${this.selectedLocation.storeName}. You will get ${helper.dataFormat(plan.data_limit * 1024 * 1024)} internet for ${helper.timeFormat(plan.time_limit)}`
            console.log('sms: ', text)
            text = `sms:${this.templateModel.mobile}?body=` + encodeURIComponent(text);
            smser.setAttribute('href', text)
            smser.click();
            this.close(options)
          }
        });
      },
      getPlan: function () {
        let newPlan = {
          active: false,
          name: `₹ ${this.templateModel.price}: ${this.templateModel.data} ${this.templateModel.dataUnit} for ${this.templateModel.time} ${this.templateModel.timeUnit}`,
          time_limit: this.templateModel.time,
          data_limit: this.templateModel.data,
          price: this.templateModel.isFreePlan ? 0 : this.templateModel.price,
          concurrent_devices: this.templateModel.devices || 1,
          mobile: this.templateModel.mobile
        };

        if(!this.templateModel.price) {
          newPlan.name = `Free plan: ${this.templateModel.data} ${this.templateModel.dataUnit} for ${this.templateModel.time} ${this.templateModel.timeUnit}`;
        }
        if (this.templateModel.dataUnit != "MB") {
          newPlan.data_limit = this.templateModel.data * 1024;
        }
        if (this.templateModel.timeUnit == "Min.") {
          newPlan.time_limit = this.templateModel.time * 60;
        } else if (this.templateModel.timeUnit == "Hours") {
          newPlan.time_limit = this.templateModel.time * 60 * 60;
        } else if (this.templateModel.timeUnit == "Day") {
          newPlan.time_limit = this.templateModel.time * 60 * 60 * 24;
        }
        return newPlan;
      },
      close: function(options) {
        if(options && options.dialog)
          options.dialog.value = false;
        this.showPopup = !this.showPopup;
        setTimeout(() => {
          this.reset();
        }, 1000);
      },
      reset: function() {
        this.templateModel.devices = 1;
        this.templateModel.time = '';
        this.templateModel.data = '';
        this.templateModel.price = '';
        this.templateModel.mobile = '';
        this.templateModel.dataUnit = 'MB';
        this.templateModel.timeUnit = "Min.";
        this.templateModel.screen = 'policy';
        //this.buttons.RED.text = 'Next';
      }
    }
  }
</script>